import Vue from "vue";
import VuejsDialog from "vuejs-dialog";
import VueToastr2 from 'vue-toastr-2';
import Editor from "@tinymce/tinymce-vue";
import "vue-select/dist/vue-select.css";


/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;
window.toastr = require('toastr');
window.htmlparser = require('htmlparser2');
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.SITE_CONFIG.csrfToken;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

export const eventBus = new Vue();

Vue.config.devtools = true;
Vue.component('home', require('./components/Home').default);

Vue.component('base-variables', require('./components/BaseVariables').default);
Vue.component('image-uploader', require('./components/ImageUploader').default);
Vue.component('select3', require('./components/Modules/Select3').default);
Vue.component('editor', Editor);
Vue.component('page-with-tabs', require('./components/PageWithTabs').default);

Vue.component('list-renderer', require('./components/ListRenderer').default);

/* Audits */
Vue.component('audit-users-list', require('./components/Audits/AuditsByUserLogsList').default);
Vue.component('audit-logs-by-months-list', require('./components/Audits/AuditsLogsByMonthsList').default);

/* Article */
Vue.component('list-filter', require('./components/Article/ListFilter').default);
Vue.component('article-list', require('./components/Article/ArticleList').default);

/* Article Edit */
Vue.component('article-editor', require('./components/Article/ArticleEditor').default);
Vue.component('article-editor-content', require('./components/Article/ArticleEditorContent').default);
Vue.component('article-editor-general', require('./components/Article/ArticleEditorGeneral').default);
Vue.component('article-editor-advanced', require('./components/Article/ArticleEditorAdvanced').default);
Vue.component('article-editor-health-checker', require('./components/Article/ArticleEditorHealthChecker').default);
Vue.component('article-editor-labels', require('./components/Article/ArticleEditorLabels').default);
Vue.component('article-editor-translators', require('./components/Article/ArticleEditorTranslators').default);

/* Article Commercial */
Vue.component('article-commercial', require('./components/Article/ArticleCommercial').default);
Vue.component('article-commercial-summaries', require('./components/Article/ArticleCommercialSummaries').default);
Vue.component('article-commercial-summary-editor', require('./components/Article/ArticleCommercialSummaryEditor').default);
Vue.component('article-commercial-recommended-providers', require('./components/Article/ArticleCommercialRecommendedProviders').default);
Vue.component('article-commercial-technical', require('./components/Article/ArticleCommercialTechnical').default);
Vue.component('article-commercial-translators', require('./components/Article/ArticleCommercialTranslators').default);

/* Article Meta & Seo */
Vue.component('article-meta-seo', require('./components/Article/ArticleMetaSeo.vue').default);
Vue.component('article-meta-seo-recommended-articles', require('./components/Article/ArticleMetaSeoRecommendedArticles.vue').default);
Vue.component('article-meta-seo-redirects', require('./components/Article/ArticleMetaSeoRedirects.vue').default);

Vue.component('module-metaseo', require('./components/Modules/moduleMetaseo').default);

/* Comments */
Vue.component('comments-list', require('./components/Comments/CommentsList').default);

/* Categories */
Vue.component('category-list', require('./components/Categories/CategoryList').default);
Vue.component('category-editor', require('./components/Categories/CategoryEditor').default);

/* Utils */
Vue.component('lang-selector', require('./components/LangSelector').default);
Vue.component('meta-tags-card', require('./components/MetaTagsCard').default);
Vue.component('site-selector', require('./components/SiteSelector').default);
Vue.component('secondary-navigation', require('./components/SecondaryNavigation').default);
Vue.component('paginator', require('./components/Paginator').default);
Vue.component('paginator-api', require('./components/PaginatorApi.vue').default);
Vue.component('top-nav', require('./components/TopNav').default);
Vue.component('loader', require('./components/Modules/Loader').default);

/* User List */
Vue.component('user-list-container', require('./components/User/UserListContainer').default);
Vue.component('user-list', require('./components/User/UserList').default);
Vue.component('user-item', require('./components/User/UserItem').default);
Vue.component('user-list-filter', require('./components/User/UserListFilter').default);

/* User Page */
Vue.component('user-page', require('./components/User/UserPage').default);
Vue.component('user-general-container', require('./components/User/UserGeneralContainer').default);
Vue.component('user-editorial-container', require('./components/User/UserEditorialContainer').default);
Vue.component('user-mentions-container', require('./components/User/UserMentionsContainer').default);
Vue.component('user-permissions-container', require('./components/User/UserPermissionsContainer').default);

// HR
Vue.component('hr-days-off', require('./components/HR/DaysOff').default);
Vue.component('hr-events', require('./components/HR/Events').default);
Vue.component('hr-pending-requests', require('./components/HR/PendingRequests').default);

/* Settings */
Vue.component('settings-page', require('./components/Settings/SettingsPage').default);
Vue.component('settings-homepage', require('./components/Settings/SettingsHomepage').default);
Vue.component('settings-hub-pages', require('./components/Settings/SettingsHubPages').default);
Vue.component('settings-providers', require('./components/Settings/SettingsProviders').default);
Vue.component('settings-about-us', require('./components/Settings/SettingsAboutUs').default);

/* Languages & Translations */
Vue.component('languages-page', require('./components/Languages/LanguagesPage').default);
Vue.component('translation-list-container', require('./components/Translations/TranslationListContainer').default);
Vue.component('translation-list', require('./components/Translations/TranslationList').default);
Vue.component('translation-container', require('./components/Translations/TranslationsContainer').default);
Vue.component('translation-lister', require('./components/Translations/TranslationsLister').default);
Vue.component('translation-summary-settings-lister', require('./components/Translations/SummarySettingsLister').default);
Vue.component('translation-properties-lister', require('./components/Translations/PropertiesLister').default);
Vue.component('translation-list-filter', require('./components/Translations/TranslationListFilter').default);

/* Tools-hub */
Vue.component('staticpage-index', require('./components/ToolsHub/StaticPagesIndex').default);
Vue.component('staticpage-basepage', require('./components/ToolsHub/StaticPageBase').default);
Vue.component('staticpage-module-content', require('./components/ToolsHub/modules/ContentEditor').default);
Vue.component('staticpage-module-recommendedArticles', require('./components/ToolsHub/modules/RecommendedArticles').default);
Vue.component('staticpage-module-settings', require('./components/ToolsHub/modules/StaticPageSettings.vue').default);
Vue.component('toolshub-worldprivacyreport', require('./components/ToolsHub/tools/CountriesHub').default);
Vue.component('toolshub-ruinmysearchhistory', require('./components/ToolsHub/tools/RMSH').default);
Vue.component('toolshub-netflixtool', require('./components/ToolsHub/tools/NetflixTool').default);

/* Labels */
Vue.component('labels-page', require('./components/Labels/LabelsPage').default);

/* Charts */
Vue.component('charts-list', require('./components/Charts/List').default);

/* Large Data Tables */
Vue.component('large-data-tables', require('./components/LargeDataTables/LargeDataTablesPage').default);

/* Countries Hub */
Vue.component('countrieshub-list', require('./components/CountriesHub/CountriesHubPage').default);

/* Coupon */
Vue.component('coupon', require('./components/Coupon/CouponList').default);

/* Loophole */
Vue.component('loophole', require('./components/Loopholes/Loophole.vue').default);
Vue.component('loophole-create', require('./components/Loopholes/LoopholeCreate.vue').default);
Vue.component('loophole-edit', require('./components/Loopholes/LoopholeEdit.vue').default);

/* Writers' Guide */
Vue.component('writers-guide-page', require('./components/WritersGuide/WritersGuidePage').default);

Vue.component('provider-lister', require('./components/Providers/ProviderLister').default);

/* Provider Lists */
Vue.component('provider-list-page', require('./components/ProviderLists/ProviderListsPage').default);
Vue.component('provider-list-editor', require('./components/ProviderLists/ProviderListEditor').default);
Vue.component('provider-list-editor-general', require('./components/ProviderLists/ProviderListEditorGeneral').default);
Vue.component('provider-list-editor-sharing', require('./components/Modules/ProviderListSharingModule').default);
Vue.component('provider-list-create', require('./components/ProviderLists/ProviderListCreate').default);

/* Provider Types */
Vue.component('provider-type-list-container', require('./components/Providers/ProviderTypes/ProviderTypeListContainer').default);
Vue.component('provider-type-list', require('./components/Providers/ProviderTypes/ProviderTypeList').default);
Vue.component('provider-type-list-filter', require('./components/Providers/ProviderTypes/ProviderTypeListFilter').default);
Vue.component('provider-type-page', require('./components/Providers/ProviderTypes/ProviderTypePage').default);
Vue.component('provider-list-container', require('./components/Providers/ProviderTypes/ProviderListContainer').default);
Vue.component('provider-list-filter', require('./components/Providers/ProviderTypes/ProviderListFilter').default);
Vue.component('provider-list-filter-api', require('./components/Providers/ProviderTypes/ProviderListFilterApi').default);
Vue.component('provider-type-settings-container', require('./components/Providers/ProviderTypes/ProviderTypeSettingsContainer').default);
Vue.component('provider-type-groups-container', require('./components/Providers/ProviderTypes/ProviderTypeGroupsContainer').default);
Vue.component('provider-type-property-editor', require('./components/Providers/ProviderTypes/ProviderTypePropertyEditor').default);
Vue.component('provider-type-summary-settings', require('./components/Providers/ProviderTypes/ProviderTypeSummarySettings').default);
Vue.component('provider-type-review-settings', require('./components/Providers/ProviderTypes/ProviderTypeReviewSettings').default);
Vue.component('provider-type-meta-seo-container', require('./components/Providers/ProviderTypes/ProviderTypeMetaSeoContainer').default);
Vue.component('provider-type-category-settings', require('./components/Providers/ProviderTypes/ProviderTypeCategorySettings').default);

/* Providers */
Vue.component('provider-page', require('./components/Providers/ProviderPage').default);
Vue.component('provider-commercial-container', require('./components/Providers/ProviderCommercialContainer').default);
Vue.component('provider-commercial-alternatives', require('./components/Providers/ProviderCommercialAlternatives').default);
Vue.component('provider-affiliate-links', require('./components/Providers/ProviderAffiliateLinks').default);
Vue.component('provider-properties-container', require('./components/Providers/ProviderPropertiesContainer').default);
Vue.component('provider-pricing', require('./components/Providers/ProviderPricingContainer').default);
Vue.component('provider-general', require('./components/Providers/ProviderGeneral').default);
Vue.component('provider-change-request-container', require('./components/Providers/ProviderChangeRequestContainer').default);
Vue.component('provider-in-articles', require('./components/Providers/ProviderInArticlesContainer').default);
Vue.component('provider-review-editor', require('./components/Providers/Reviews/ProviderReviewEditor').default);
Vue.component('provider-review-editor-content', require('./components/Providers/Reviews/ProviderReviewEditorContent').default);
Vue.component('provider-review-editor-general', require('./components/Providers/Reviews/ProviderReviewEditorGeneral').default);
Vue.component('provider-review-editor-toc-helper', require('./components/Providers/Reviews/ProviderReviewEditorTocHelper').default);
Vue.component('provider-review-editor-video-helper', require('./components/Providers/Reviews/ProviderReviewEditorVideoHelper').default);
Vue.component('provider-review-editor-health-checker', require('./components/Providers/Reviews/ProviderReviewEditorHealthChecker').default);
Vue.component('provider-review-meta-seo', require('./components/Providers/Reviews/ProviderReviewMetaSeo').default);
Vue.component('provider-review-technical', require('./components/Providers/Reviews/ProviderReviewTechnical').default);
Vue.component('provider-compare', require('./components/Providers/ProviderComparison').default);

/* User Review Comments */
Vue.component('user-review-comments-list', require('./components/Providers/UserReviews/UserReviewCommentsList').default);

/* Provider Portal User List */
Vue.component('pp-user-container', require('./components/ProviderPortal/Users/Container').default);
Vue.component('pp-user-list', require('./components/ProviderPortal/Users/List').default);
Vue.component('pp-user-item', require('./components/ProviderPortal/Users/ListItem').default);
Vue.component('pp-user-filter', require('./components/ProviderPortal/Users/Filter').default);

/* Provider Portal  User Page */
Vue.component('pp-user-page', require('./components/ProviderPortal/Users/EditForm').default);

/* Redirects */
Vue.component('redirects-page', require('./components/Redirects/RedirectsPage').default);

// Seo
Vue.component('seo', require('./components/Seo/Seo').default);

// Dashboard
Vue.component('stats-provider', require('./components/Dashboard/StatsProvider').default);
Vue.component('stats-provider-create', require('./components/Dashboard/StatsProviderCreate').default);
Vue.component('stats-provider-list', require('./components/Dashboard/StatsProviderList').default);
Vue.component('commission-small-report', require('./components/Dashboard/CommissionSmallReport').default);

Vue.use(VuejsDialog);
Vue.use(VueToastr2);

window.toastr.options.closeButton = true;
window.toastr.options.progressBar = true;
window.toastr.options.timeOut = 2000;
window.toastr.options.extendedTimeOut = 4000;

Vue.directive('click-outside', {
	bind(el, binding, vnode) {
		var vm = vnode.context;
		var callback = binding.value;

		el.clickOutsideEvent = function (event) {
			if (!(el == event.target || el.contains(event.target))) {
				return callback.call(vm, event);
			}
		};
		document.body.addEventListener('click', el.clickOutsideEvent);
	},
	unbind(el) {
		document.body.removeEventListener('click', el.clickOutsideEvent);
	}
});

const app = new Vue({
	el: '#app'
});
